export const RESI_TEST_APP_BUILD_ENVS = {
  INTEGRATION: 'integration',
  PRODUCTION: 'production',
} as const;

export const RESI_TEST_APP_EMBED_VALUES = {
  TRUE: 'true',
  FALSE: 'false',
} as const;
